import React from "react";
import { Link, withRouter } from "react-router-dom";
import { useQuery, useMutation } from "@apollo/client";
import { Breadcrumb, Loader, Header, Message } from "semantic-ui-react";
import moment from "moment";
import {
  GET_STUDENT_REPORT,
  UPDATE_STUDENT_REPORT,
  SEND_STUDENT_REPORT,
  DELETE_STUDENT_REPORT,
  getReportInput,
} from "../GraphQL";
import ReportForm from "../components/ReportForm";
import { capitalize } from "utils";

const ReportEditPage = ({ match, history, accessReason }) => {
  const { studentId, reportId } = match.params;
  const { error, loading, data } = useQuery(GET_STUDENT_REPORT, {
    variables: { studentId, reportId, accessReason },
  });

  const [sendReport] = useMutation(SEND_STUDENT_REPORT);
  const [updateReport] = useMutation(UPDATE_STUDENT_REPORT);

  const [deleteReport] = useMutation(DELETE_STUDENT_REPORT);

  if (loading) {
    return <Loader active />;
  }
  if (error) {
    throw error;
  }

  const student = data.getStudent;

  if (!student.report) {
    return (
      <Message negative>
        <Message.Header>Report not found.</Message.Header>
        <p>This report no longer exists.</p>
      </Message>
    );
  }

  const reportDate = moment(student.report.date).format("LL");
  const reportTitle = `${capitalize(student.report.reportType)} Report for ${
    student.name
  }`;

  return (
    <div>
      <div
        style={{
          backgroundColor: "#fff",
          position: "sticky",
          top: 55,
          zIndex: 1,
        }}
      >
        {" "}
        <Breadcrumb size="tiny">
          <Breadcrumb.Section>
            <Link to="/">Home</Link>
          </Breadcrumb.Section>
          <Breadcrumb.Divider icon="right angle" />
          <Breadcrumb.Section>
            <Link to={`/students/${student.id}`}>{student.name}</Link>
          </Breadcrumb.Section>
          <Breadcrumb.Divider icon="right angle" />
          <Breadcrumb.Section active>Edit Report</Breadcrumb.Section>
        </Breadcrumb>
        <Header
          style={{ backgroundColor: "#fff", marginBottom: "1em" }}
          as="h3"
          subheader={reportDate}
          content={reportTitle}
          dividing
        />
      </div>
      <ReportForm
        report={student.report}
        isNew={false}
        canAddAttachments={student.myTeacher.isProUser}
        onCancel={() => history.push(`/students/${student.id}`)}
        onDelete={() => {
          deleteReport({
            variables: {
              id: student.report.id,
            },
            onCompleted: () => {
              history.push(`/students/${student.id}`);
            },
            update: (cache, { data: { deleteReport } }) => {
              console.log("update", deleteReport);
              cache.modify({
                id: `Student:${student.id}`,
                fields: {
                  pagedReports(existingPagedReports = [], { readField }) {
                    return {
                      ...existingPagedReports,
                      reports: existingPagedReports.reports.filter(
                        (ref) => readField("id", ref) !== deleteReport.id
                      ),
                    };
                  },
                },
              });
            },
          });
        }}
        onSend={async () => {
          await sendReport({
            variables: {
              student: match.params.studentId,
              report: student.report.id,
            },
            onCompleted: () => {
              history.push(`/students/${student.id}`);
            },
            update: (cache, { data: { sendReport } }) => {
              console.log("update", sendReport);
              cache.modify({
                id: cache.identify(student.report),
                fields: {
                  sent(existingSent = false) {
                    return true;
                  },
                },
              });
            },
          });
        }}
        onSave={async (report) => {
          const updatedReport = Object.assign({}, student.report, report);
          await updateReport({
            variables: { input: getReportInput(updatedReport) },
          });
        }}
      />
    </div>
  );
};

export default withRouter(ReportEditPage);
